import { StyledAccordion } from '@/reports/export/ExportModal/styledComponents';
import { DataCard } from '@/reports/shared/DataCard/DataCard';
import { AutomobileRepairQuote } from '@/reports/types/vehicles';
import { generateSectionIdentifyingData } from '@/reports/vehicle/VehicleReport';
import { Text, Box, Table } from '@/theme/index';
import { commaFormatCurrency, formatDateFromReport } from '@/utils/index';
import { VehicleRepairQuoteParts } from './VehicleRepairQuoteParts/VehicleRepairQuoteParts';

interface VehicleRepairQuoteCardProps {
  repairQuote: AutomobileRepairQuote;
}

export const VehicleRepairQuoteCard = ({
  repairQuote,
}: VehicleRepairQuoteCardProps) => {
  const vehicleIdentifyingData = generateSectionIdentifyingData(repairQuote);
  const totalPartsCost =
    repairQuote.parts.length <= 0
      ? 0
      : repairQuote.parts.reduce((acc, item) => acc + (item.price || 0), 0);

  return (
    <DataCard testId="vehicle-repair-quote-card">
      <Text
        variant="h3"
        fontWeight="normal"
        mb={0}
        data-cy="vehicle-repair-quote-card-title"
      >
        Reported
        {repairQuote.create_date?.full && (
          <>
            <Text variant="h3" fontWeight="normal" component="span">
              {' '}
              on
            </Text>
            <Text variant="h3" component="span">
              {' '}
              {formatDateFromReport(repairQuote.create_date.full)}
            </Text>
            {totalPartsCost > 0 && (
              <>
                <Text variant="h3" fontWeight="normal" component="span">
                  {' '}
                  totaling
                </Text>
                <Text variant="h3" component="span">
                  {' '}
                  {commaFormatCurrency(totalPartsCost)}
                </Text>
              </>
            )}
          </>
        )}
      </Text>
      {Boolean(parseInt(repairQuote.is_insurance, 10)) && (
        <Box
          display="flex"
          flexDirection="row"
          alignItems="baseline"
          data-cy="vehicle-repair-quote-insurance-company"
        >
          <Text variant="h4" mb={0}>
            Insurance Company:
          </Text>
          <Text variant="body2" ml={1}>
            {repairQuote.insurance_company}
          </Text>
        </Box>
      )}
      {Boolean(repairQuote.parts.length) && (
        <VehicleRepairQuoteParts parts={repairQuote.parts} />
      )}
      {vehicleIdentifyingData.length > 0 && (
        <StyledAccordion display="Identifying information">
          <Table className="striped flipped" rows={vehicleIdentifyingData} />
        </StyledAccordion>
      )}
    </DataCard>
  );
};
